import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing a view for filtering registered documents.
 * @extends JetView
 */
export default class FilterRegisteredDocumentView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id', // Input field for user ID
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    labelPosition: 'top',
                    placeholder: _('ID Usuario'),
                },
                {
                    view: 'richselect',
                    name: 'Type', // Dropdown for document type selection
                    label: _('Tipo'),
                    labelPosition: 'top',
                    placeholder: _('Tipo'),
                    value: '',
                    options: [
                        { id: '0', value: _('Todos') },
                        { id: '1', value: _('Documento 1') },
                        { id: '2', value: _('Documento 2') },
                    ],
                },
            ],
        };

        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Name', // Input field for name
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                },
                {
                    view: 'richselect',
                    name: 'IsActivate', // Dropdown for activation status
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: '',
                    options: [
                        { id: '0', value: _('Todos') },
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                    ],
                },
            ],
        };

        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Route', // Input field for route
                    label: _('Ruta'),
                    labelPosition: 'top',
                    placeholder: _('Ruta'),
                },
            ],
        };

        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Version', // Input field for version
                    label: _('Versión'),
                    labelPosition: 'top',
                    placeholder: _('Versión'),
                },
            ],
        };

        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout structure
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { gravity: 1, id: 'grav' }, // Placeholder for responsive behavior
                        {
                            view: 'button',
                            value: _('Añadir Documento'), // Button to add document
                            type: 'form',
                            width: screen == 'small' ? 0 : 200,
                            minWidth: 200,
                            click: () => {
                                this.app.callEvent('addDocument:button', [{}]); // Event to add document
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Button to clear form
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Button to consult/filter documents
                            hotkey: 'enter', // Shortcut key
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent(
                                    'registeredDocument:filter',
                                    [filterdata], // Event to filter documents
                                );
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            rows: [upper_section, buttons], // Main layout structure
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element on small screens
            }
        });
    }
}

// FILE DOCUMENTED
